'use client'

/**
 * The user menu's "Demo Mode" entry (#5326): enter demo mode, then hard-load
 * the demo entry path. Shared by the header's user menu and the side
 * navigation's account menu (#15618), which both offer the entry.
 *
 * The action is imported on demand, as it always was from the header: it is
 * only ever needed after a click.
 */

import { useCallback, useState } from 'react'

import { DEMO_ENTRY_PATH } from '@/lib/demo-entry-path'
import { toastError } from '@/lib/toast'

export function useEnterDemoMode() {
  const [isEnteringDemo, setIsEnteringDemo] = useState(false)

  const enterDemoMode = useCallback(async () => {
    setIsEnteringDemo(true)
    try {
      const { enterDemoMode: enter } = await import('@/app/actions/demo-mode')
      const result = await enter()
      if (result.success) {
        window.location.href = DEMO_ENTRY_PATH
      } else {
        toastError({
          message: result.error ?? 'Failed to enter demo mode',
          context: { action: 'enterDemoMode' },
        })
      }
    } finally {
      setIsEnteringDemo(false)
    }
  }, [])

  return { isEnteringDemo, enterDemoMode }
}
